import { axiosInstance } from '@/config/axios.config';
import {
  CreateIdentifiedSymptomRequest,
  IdentifiedSymptom,
  UpdateIdentifiedSymptomRequest,
} from '@repo/types/src/identified-symptom';

export const getAllIdentifiedSymptoms = async (): Promise<
  IdentifiedSymptom[]
> => {
  const response = await axiosInstance.get<IdentifiedSymptom[]>(
    '/identified-symptoms',
  );
  return response.data;
};

export const createIdentifiedSymptom = async (
  payload: CreateIdentifiedSymptomRequest,
): Promise<IdentifiedSymptom> => {
  const response = await axiosInstance.post<IdentifiedSymptom>(
    '/identified-symptoms',
    payload,
  );
  return response.data;
};

export const updateIdentifiedSymptom = async (
  id: number,
  payload: UpdateIdentifiedSymptomRequest,
): Promise<IdentifiedSymptom> => {
  const response = await axiosInstance.patch<IdentifiedSymptom>(
    `/identified-symptoms/${id}`,
    payload,
  );
  return response.data;
};

export const deleteIdentifiedSymptom = async (
  id: number,
): Promise<IdentifiedSymptom> => {
  const response = await axiosInstance.delete<IdentifiedSymptom>(
    `/identified-symptoms/${id}`,
  );
  return response.data;
};
